<div class="terms-conditions" data-oa-el-id="sega">
  <!--THE LANDOWNER'S TERMS AND CONDITIONS-->

  <spinner *ngIf="initializing" messageRelativePosition="bottom"> </spinner>

  <div
    class="text-center"
    *ngIf="landOwnerTerms !== undefined && (landOwnerTerms.propertyRules.length > 0)"
  >
    <h4>Land Owner's Terms & Conditions</h4>

    <ng-container *ngIf="!initializing">
      <p *ngIf="landOwnerTerms.propertyRules.length > 0" [innerHTML]="landOwnerTerms?.propertyRules | newlineToParagraph"></p>
    </ng-container>
  </div>

  <div class="text-center">
    <h4>Outdoor Access Terms and Conditions</h4>
    <p>
      {{ oaTermsAndConditionText }}
    </p>
  </div>

  <div class="terms">
    By continuing, I agree to Outdoor Access's cancellation policy, Outdoor Access's
    <a href="user/agreement" target="terms">terms and conditions</a> and the landowner's terms and conditions.
  </div>

  <div class="btn-continue">
    <button
      [disabled]="initializing"
      id="booking-terms-i-agree-button"
      type="button"
      class="btn btn-primary btn-lg btn-lg-round btn-block"
      (click)="onAgreeClick()"
    >
      <i *ngIf="loading" class="fa fa-circle-notch fa-spin"></i>
      I Agree
    </button>
  </div>
</div>
